import { RestService } from '../RestService';

export class C8yBaseService extends RestService {
  protected setBaseUrl() {
    super.setBaseUrl();

    this.baseUrl = `${this.baseUrl}/c8y`;
  }
}
